import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, ContentTemplate, TitleHeader } from 'web-library';
import ExamReceipt from '../../modules/examRegistration/components/ExamReceipt';

const Receipt = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <TitleHeader
        state="success"
        title={t('exam->>ExamReceipt.SubmittedExam')}
        largeContentContainer
      />
      <ContentTemplate>
        <ExamReceipt />
      </ContentTemplate>
    </Box>
  );
};

export default Receipt;
